import { v4 as uuidv4 } from "uuid";

export const ToastMessage = "toast-connect";

export enum MessageType {
    Info,
    Warning,
    Error,
}

export type ToastMessageEvent = {
    msg: string;

    /// Duration is either :-
    ///   -1  - for default clear timeout
    ///    0  - to never clear
    ///   positive number:  milliseconds before clearing
    duration: number;
    type: MessageType;
};

export type EventId = string;

class EventHandler {
    public id: EventId = uuidv4();
    constructor(public callback: any) {}
}

export class EventSystem {
    private _events: Map<string, any> = new Map<string, any>();

    subscribe(name: string, callback: any): EventId {
        const handler = new EventHandler(callback);
        this._events.has(name)
            ? this._events.get(name).Handlers.push(handler)
            : this._events.set(name, { Handlers: [handler] });
        return handler.id;
    }

    raiseEvent(name: string, args: any | undefined = undefined) {
        let i = 0;
        if (this._events.has(name)) {
            for (; i < this._events.get(name).Handlers.length; i++) {
                this._events.get(name).Handlers[i].callback.call(null, args);
            }
        }
    }

    unsubscribe(name: string, handler: any | EventId) {
        const handlers = this._events.get(name).Handlers;
        let idx = -1;
        if (typeof handler === "string" || handler instanceof String) {
            idx = handlers.findIndex((x: EventHandler) => x.id === (handler as string));
        } else {
            idx = handlers.findIndex((x: EventHandler) => x.callback === handler);
        }
        if (idx > -1) {
            this._events.get(name).Handlers.splice(idx, 1);
        }
    }
}
